import { INGEST_LEAD_PILL_KEY } from '../../agents/ingest-cot-stream-reduce'
import type { SessionPaintSelection } from '../../slices/session-paint-scope-slice'

/** Minimal agent-pill shape used to bridge chat ↔ Plant scope. */
export interface SessionScopeAgentPill {
  key: string
  sectionId?: string
  agentKind?: string
}

/**
 * Lead and reconciler show the whole job; section parsers (and any pill with a
 * section id) narrow Plant to that section.
 */
export function paintSelectionFromAgentPill(
  pill: SessionScopeAgentPill | undefined
): SessionPaintSelection {
  if (!pill) return { kind: 'all' }
  if (pill.key === INGEST_LEAD_PILL_KEY) return { kind: 'all' }
  if (pill.agentKind === 'ingest_agent' || pill.agentKind === 'ingest_reconciler') {
    return { kind: 'all' }
  }
  if (pill.sectionId) return { kind: 'section', sectionId: pill.sectionId }
  return { kind: 'all' }
}

/**
 * Pick the chat pill for a Plant scope. All / job → Lead, unless the current
 * pill already maps to All (keeps Reconciler selected). Section → matching pill.
 */
export function pillKeyForPaintSelection(
  selection: SessionPaintSelection,
  pills: readonly SessionScopeAgentPill[],
  currentKey: string
): string {
  if (selection.kind === 'section') {
    const match =
      pills.find((pill) => pill.sectionId === selection.sectionId) ??
      pills.find((pill) => pill.key === `section:${selection.sectionId}`)
    return match?.key ?? INGEST_LEAD_PILL_KEY
  }

  const current = pills.find((pill) => pill.key === currentKey)
  if (current && paintSelectionFromAgentPill(current).kind === 'all') return current.key
  return INGEST_LEAD_PILL_KEY
}
